import { Api, Globals } from 'utils';

class PlansService {

	static get = async (params?: any) => Api.createResponse(`admin/plans?${Globals.objectToQueryParams(params)}`,{},'get');
	static create = async (params?: any) => Api.createResponse('admin/plans',params);
	static update = async (params?: any) => Api.createResponse(`admin/plans/${params.id}`,params);
	static delete = async (params?: any) => Api.createResponse(`admin/plans/${params.id}`,params,'delete');
	static disable = async (params?: any) => Api.createResponse(`admin/plans/${params.id}/disable`,{},'put');
	static enable = async (params?: any) => Api.createResponse(`admin/plans/${params.id}/enable`,{},'put');

}

export default PlansService;